import type {
	GenericFilterItem,
	ParametricFilter,
	SelectedFilter
} from "@nwt/norce-pwa/dist/runtime/types/api/searchAndFilter/filters";

const isParametricOptionChecked = (
	modelValue: SelectedFilter,
	option: ParametricFilter
): boolean => {
	return !!modelValue?.[FilterTypes.PARAMETRIC]?.[
		option.ParametricId
	]?.includes(+option.Id);
};

/**
 * The id a stock option is selected and sent (`ohf|<id>`) with. Norce's
 * option has no Id, only Value "True"/"False"; `+null` became 0, which asks
 * Norce for out-of-stock products, so the Value is mapped to 1/0 here.
 */
const getStockOptionId = (
	option: Pick<GenericFilterItem, "Id" | "Value">
): number => {
	const { Id, Value } = option;
	if (Id !== null && Id !== undefined && Id !== "") return Number(Id);
	const value = String(Value ?? "").toLowerCase();
	if (value === "true") return 1;
	if (value === "false") return 0;
	return Number(Value);
};

const isStockOptionChecked = (
	modelValue: SelectedFilter,
	option: GenericFilterItem
): boolean => {
	if (!modelValue || !modelValue[FilterTypes.ONHAND]) {
		return false;
	}

	const selectedValues = modelValue[FilterTypes.ONHAND];
	if (!Array.isArray(selectedValues)) {
		return false;
	}

	return selectedValues.includes(getStockOptionId(option));
};

const isFlagOptionChecked = (
	modelValue: SelectedFilter,
	option: GenericFilterItem
): boolean => {
	if (!modelValue || !modelValue[FilterTypes.FLAG]) {
		return false;
	}

	const selectedValues = modelValue[FilterTypes.FLAG];
	if (!Array.isArray(selectedValues)) {
		return false;
	}

	return selectedValues.includes(Number(option.Value || option.Id));
};

const isArrayOptionChecked = (
	modelValue: SelectedFilter,
	option: { Id?: string | number | null },
	type: string
) => {
	const optionId = +(option?.Id ?? NaN);
	if (Number.isNaN(optionId)) return false;

	return !!modelValue?.[FilterTypes[type?.toUpperCase()]]?.includes(optionId);
};

export {
	isParametricOptionChecked,
	isArrayOptionChecked,
	getStockOptionId,
	isStockOptionChecked,
	isFlagOptionChecked
};
